import { Currency } from "@/constants/currency";
import i18n from "@/lang";
// Simplified type alias to avoid TS2589 (excessively deep type instantiation)
// caused by vue-i18n v11's complex overloaded generics on t()
const t: (key: string, ...args: unknown[]) => string = (i18n.global as any).t;
import { LogService } from "@/services/logging";
import BookingModule from "@/store/modules/booking";
import CashFloatModule from "@/store/modules/cash-float";
import POSConfigModule from "@/store/modules/pos-config";
import {
  AccountingState,
  PaymentMethods,
  TransactionTypes,
} from "@/types/db/accounting";
import { sumArray } from "../helpers/common";
import {
  bookingTotalConsideringDiscounts,
  bookingTotalTax,
  discountTotal,
  restToPay,
} from "./new-accountings";
import person from "@/assets/images/svg/person.svg";
import { groupedPSS } from "./booking";
import { BookingStep } from "@/constants/booking";
import CustomersModule from "@/store/modules/customers";
import { BookingStatus, PSSType } from "@/types/db/product-slot-state";
import { ISynchingReason } from "@/interfaces/store/IBooking";
import CommonModule from "@/store/modules/common";
import { computed } from "vue";
import DeviceModule from "@/store/modules/device";
import { getUntypedBookingByUuid, isBookingInDexie } from "../helpers/booking";

export let customerDisplayData: any = { message: "" };

export async function getCustomerBasketData() {
  console.log("hi from getCustomerBasketData");
  const isLongTitle = String(t("asideordersummary.title")).length > 15;

  const iconStyle =
    "width: 20px; height: 20px; filter: brightness(0) saturate(100%) contrast(170%) invert(100%);";
  const iconContent = person;
  const iconAlt = "user";
  const groupedPSSList = groupedPSS(
    BookingModule.selectedBooking ? BookingModule.selectedBooking.pssList : []
  ); /* computed(() => {
      const gr = groupedPSS();
      return gr;
        });*/

  const bookingStep = BookingModule.bookingStep; /*computed(() => {
      const b = BookingModule.bookingStep;
      return b;
    });*/

  const isInPaymentStep =
    bookingStep === BookingStep.Payment ||
    bookingStep === BookingStep.Discount ||
    bookingStep === BookingStep.Promocode ||
    bookingStep === BookingStep.PromocodeCampaigns ||
    bookingStep === BookingStep.Offers;

  const isCompletedBooking =
    BookingModule.bookingStep === BookingStep.CompleteOrder;

  function CustomerFullName(): string {
    const customer = CustomersModule.selectedCustomers.find(
      (c: any) => c.bookingUuid === BookingModule.selectedBookingUUID
    );
    if (customer) {
      return customer.fullName;
    }
    return "";
  }

  const getCustomerFullName = CustomerFullName();

  const hasAppliedDiscount =
    !!BookingModule.selectedBookingDiscountTrack &&
    BookingModule.selectedBookingDiscountTrack.isApplied;

  const isDiscountOnAllOrder =
    BookingModule.selectedBookingDiscountTrack?.isOnAllOrder || false;

  const discountTotal1 = discountTotal.value;

  const whatIsLeftToPay = (restToPay.value / 100).toFixed(2);

  const total1 = (bookingTotalConsideringDiscounts.value / 100).toFixed(2);

  // total tax amount
  const totalTax = (bookingTotalTax.value / 100).toFixed(2);

  const translatePaymentMethods = (paymentMethod: string) => {
    switch (paymentMethod) {
      case "CASH":
        return t("settings.payment-methods.cash");
      case "POS_CARD":
        return t("payment-method.CARD");
      case "INVOICE":
        return t("payment-method.INVOICE");
      case "TO_BE_INVOICED":
        return t("payment-method.TO_BE_INVOICED");
      case "BANK_TRANSFER":
        return t("payment-method.BANK_TRANSFER");
      case "UNKNOWN":
        return t("payment-method.UNKNOWN");
      case "POS_ADYEN":
        return t("payment-method.POS_ADYEN");
      // case "DISCOUNT":
      //   return t("button.discount");
      case "POS_DISCOUNT":
        return t("payment-method.POS_DISCOUNT");
      case "FREE":
        return t("payment-method.FREE");
      case "CHEQUE":
        return t("payment-method.CHEQUE");
      case "CHEQUE_VACANCES":
        return t("payment-method.CHEQUE_VACANCES");
      case "CHEQUE_CULTURE":
        return t("payment-method.CHEQUE_CULTURE");
      case "PASS_CULTURE":
        return t("payment-method.PASS_CULTURE");
      case "CHORUS":
        return t("payment-method.CHORUS");
      // case "CE":
      //   return t("button.CE");
      // case "OCCYG":
      //   return t("button.OCCYG");
      case "POS_PROMO_CODE":
        return t("payment-method.POS_PROMO_CODE");
      case "POS_VOUCHER":
        return t("payment-method.VOUCHER");
      case "GIFT_CARD":
        return t("payment-method.GIFT_CARD");
      case "POS_MEMBERSHIP":
        return t("payment-method.POS_MEMBERSHIP");
      case "AMEX":
        return t("payment-method.AMEX");
      case "CE":
        return t("payment-method.CE");
      case "COUPON_SPORT":
        return t("payment-method.COUPON_SPORT");
      case "DISCOUNT":
        return t("payment-method.DISCOUNT");
      case "EXPERIENCEBANK":
        return t("payment-method.EXPERIENCEBANK");
      case "EXTERNAL_VOUCHER":
        return t("payment-method.EXTERNAL_VOUCHER");
      case "invitation":
        return t("payment-method.invitation");
      case "KIOSK_ADYEN":
        return t("payment-method.KIOSK_ADYEN");
      case "MASTERCARD":
        return t("payment-method.MASTERCARD");
      case "MEMBERSHIP":
        return t("payment-method.MEMBERSHIP");
      case "OCCYG":
        return t("payment-method.OCCYG");
      case "PAYPAL":
        return t("payment-method.PAYPAL");
      case "POS_ADYEN_CREATE_ORDER":
        return t("payment-method.POS_ADYEN_CREATE_ORDER");
      case "POS_BANK_TRANSFER":
        return t("payment-method.POS_BANK_TRANSFER");
      // case "POS_CARD":
      // return t("payment-method.POS_CARD");
      case "POS_CASH":
        return t("payment-method.POS_CASH");
      case "POS_EXTERNAL":
        return t("payment-method.POS_EXTERNAL");
      case "POS_GIFT_CARD":
        return t("payment-method.POS_GIFT_CARD");
      case "POS_INVITATION":
        return t("payment-method.POS_INVITATION");
      case "POS_INVOICE":
        return t("payment-method.POS_INVOICE");
      case "POS_TWINT":
        return t("payment-method.POS_TWINT");
      case "POSTCARD":
        return t("payment-method.POSTCARD");
      case "POSTEFINANCE":
        return t("payment-method.POSTEFINANCE");
      case "PROMO_CODE":
        return t("payment-method.PROMO_CODE");
      case "QOQA_VOUCHER":
        return t("payment-method.QOQA_VOUCHER");
      case "REFUNDED_VOUCHER":
        return t("payment-method.REFUNDED_VOUCHER");
      case "SPONSORED":
        return t("payment-method.SPONSORED");
      case "STAND_ALONE_ADYEN":
        return t("payment-method.STAND_ALONE_ADYEN");
      case "TWINT":
        return t("payment-method.TWINT");
      case "VISA":
        return t("payment-method.VISA");
      case "POS_ADYEN_PAY_BY_LINK":
        return t("payment-method.POS_ADYEN_PAY_BY_LINK");
      case "POS_REKA":
        return t("payment-method.POS_REKA");
      case "POS_DIVERSE_VOUCHER":
        return t("payment-method.POS_DIVERSE_VOUCHER");

      case "CFF":
        return t("payment-method.cff");
      case "CGN":
        return t("payment-method.cgn");
      case "QOQA":
        return t("payment-method.qoqa");
      case "DEINDEAL":
        return t("payment-method.deindeal");
      case "REALDEAL":
        return t("payment-method.realdeal");
      case "INCERT_VOUCHER":
        return t("payment-method.Incert_Voucher");
      case "Swiss_QR_Code_Bank_Transfer":
        return t("payment-method.BANK_TRANSFER_SWISS_QR");
      case "BUY_CLUB":
        return t("payment-method.BUY_CLUB");
      case "POS_BIMPLI_CADO":
        return t("payment-method.POS_BIMPLI_CADO");
      case "POS_KADEOS_INFINI":
        return t("payment-method.POS_KADEOS_INFINI");
      case "POS_ANCV_CONNECT":
        return t("payment-method.POS_ANCV_CONNECT");
      case "TOUT_UN_CANTON":
        return t("payment-method.TOUT_UN_CANTON");
      case "CHAPLINS":
        return t("payment-method.CHAPLINS");
      case "HELLO_CSE":
        return t("payment-method.HELLO_CSE");
      case "Z_CH_GUTSCHEIN":
        return t("payment-method.Z_CH_GUTSCHEIN");
    }
  };

  function getSplitPayments() {
    // We show completed accountings as split payments. And we also show with them
    // a cash payment that has been added by the user but hasn't been confirmed yet
    // and we also show with them any payment code that is applied in this booking session
    const paidAmounts = BookingModule.selectedBooking?.accountings.filter(
      (acc) =>
        acc.transactionType === 1 &&
        (acc.state === AccountingState.Completed ||
          (acc.state === AccountingState.Pending &&
            !acc.id /*making sure it is not coming from backend*/ &&
            (acc.promocode || acc.promoCodeUuid)) ||
          (acc.state === AccountingState.Pending &&
            acc.paymentMethod === PaymentMethods.METHOD_POS_CASH))
    );

    const currencies1 = currencies();
    console.log(currencies);

    const toBeReturned = paidAmounts
      ?.map((acc) => {
        return {
          translatedMethod: translatePaymentMethods(acc.paymentMethod),
          method: acc.paymentMethod,
          accountingUuid: acc.uuid,
          accountingId: acc.id,
          state: acc.state,
          updatedAt: acc.updatedAt,
          createdAt: acc.createdAt,
          currency: currencies1.find((c) => c.label === acc.paymentCurrency),
          amount: sumArray(
            acc.accountingEntriesList.map((it) => it.value / 100)
          ),
          exchangeRate: acc.exchangeRate,
          cashBill: acc.providedCashBill ? acc.providedCashBill / 100 : 0,
        };
      })
      .flat();
    return toBeReturned;
  }
  const splitPayments = getSplitPayments();
  console.log(splitPayments);

  const currenciesUsedInPayment = getCurrenciesUsedInPayment();
  function getCurrenciesUsedInPayment() {
    console.log("start of getCurrenciesUsedInPayment");
    const currencies: Currency[] = [];
    if (!splitPayments?.length) {
      return currencies;
    }
    splitPayments.forEach((splitPayment) => {
      if (
        !splitPayment?.currency ||
        currencies.includes(splitPayment.currency)
      ) {
        return;
      }
      currencies.push(splitPayment.currency);
    });
    console.log("end of getCurrenciesUsedInPayment");
    return currencies;
  }

  function currencies() {
    const currencies: Currency[] = [];
    const startAmounts = CashFloatModule.cashFloat?.startAmounts;
    for (const currency in startAmounts) {
      const currencyInfo = POSConfigModule.groupCurrencies.find(
        (c) => c.label === currency
      );
      if (currencyInfo) {
        currencies.push(currencyInfo);
      }
    }
    return currencies;
  }

  const groupCurrency =
    currencies().find((c) => c.isDefault === 1) || currencies()[0];
  const orderValueExcludingCancelledTickets = (
    bookingTotalConsideringDiscounts.value / 100
  ).toFixed(2);
  const confirmedAmountsInfo = BookingModule.confirmedAmounts;
  const doesSupportSplitPayment = BookingModule.doesSupportSplitPayment;

  const selectedBooking = BookingModule.selectedBooking;

  const bookingSynchingDateTime = await getBookingSynchingDateTime();

  async function getBookingSynchingDateTime() {
    const syncedBooking = await getUntypedBookingByUuid(selectedBooking?.uuid);

    return syncedBooking?.creationDateTime || "";
  }

  const groupCurrencies = POSConfigModule.groupCurrencies;

  const refundedAmount = getRefundedAmount();
  function getRefundedAmount() {
    const refundAccountings = selectedBooking?.accountings.filter(
      (acc) =>
        acc.state === AccountingState.Completed &&
        acc.refund === 1 &&
        acc.transactionType === TransactionTypes.TRANSACTION_TYPE_REFUND
    );
    let aEntries: number[] = [];
    if (refundAccountings && refundAccountings.length) {
      aEntries = refundAccountings
        .map((ac) => ac.accountingEntriesList)
        .flat()
        .map((ae) => ae.value);
    }
    const b = (-1 * sumArray(aEntries)) / 100;
    return b;
  }

  const payingCurrency = selectedBooking?.currency;

  const amountPaid = BookingModule.amountPaid;

  const isEditOrder = await isBookingInDexie(BookingModule.selectedBookingUUID);

  return {
    isLongTitle,
    iconContent,
    iconAlt,
    iconStyle,
    groupedPSSList, // This is a function but we need to make it an array that we broadcast
    BookingStatus,
    PSSType,
    isInPaymentStep,
    hasAppliedDiscount,
    isDiscountOnAllOrder,
    discountTotal1,
    isCompletedBooking,
    total1,
    totalTax,
    splitPayments,
    currenciesUsedInPayment,
    groupCurrency,
    orderValueExcludingCancelledTickets,
    confirmedAmountsInfo,
    doesSupportSplitPayment,
    PaymentMethods,
    bookingSynchingDateTime,
    AccountingState,
    payingCurrency,
    amountPaid,
    refundedAmount,
    whatIsLeftToPay,
    selectedBooking,
    getCustomerFullName,
    isEditOrder,
    groupCurrencies,
  };
}

export async function updateCustomerScreen() {
  console.log("hi from updateCustomerScreen");
  // user is displaying second screen to the customer lets refresh data
  // we will send few data to broadcast channel
  // Send data from one tab or window
  // Creating a broadcastChannel object linked to pos.smeetz
  const broadcastChannel = new BroadcastChannel("pos.smeetz");
  LogService.info("Preparing data to be shared thru broadcast channel");
  console.log("Preparing data to be shared thru broadcast channel");

  const customerBasketData = await getCustomerBasketData();
  console.log("customerBasketData");
  console.log(customerBasketData);
  // Put here all data that are going to be needed by CustomerBasket.vue
  customerDisplayData = {
    message: "Booking has been updated",
    // TODO Hamza: make below variables enumerated user actions
    isBookingUpdated: true,
    customerBasketData,
    isChartToUpdate: false,
  };
  console.log("customerDisplayData");
  console.log(customerDisplayData);
  LogService.info("Populating attached data thru broadcast channel", {
    params: customerDisplayData,
  });
  // posting a message to pos.smeetz channel
  console.log("posting the message");
  broadcastChannel.postMessage(JSON.stringify(customerDisplayData));
}

/**
 * Called whenever the user renders a seating chart
 * This function will render the same chart for the customer in Customer Display
 */
export async function renderChartInCustomerDisplay(renderedChartData: any) {
  // Creating a broadcastChannel object linked to pos.smeetz
  const broadcastChannel = new BroadcastChannel("pos.smeetz");
  LogService.info("Going to render attached chart in CustomerDisplay", {
    params: renderedChartData,
  });
  // Put here all data that are going to be needed by CustomerBasket.vue
  customerDisplayData = {
    message: "User rendered attached chart",
    isBookingUpdated: false,
    isChartToUpdate: true,
    chartData: renderedChartData,
    renderCustomerSeatingChart: true,
  };
  LogService.info("Populating attached data thru broadcast channel", {
    params: customerDisplayData,
  });
  // posting a message to pos.smeetz channel
  broadcastChannel.postMessage(JSON.stringify(customerDisplayData));
}

/**
 * Called whenever the user closes a seating chart
 * This function will close the same chart in Customer Display
 */
export async function closeChartInCustomerDisplay(renderedChartData: any) {
  // Creating a broadcastChannel object linked to pos.smeetz
  const broadcastChannel = new BroadcastChannel("pos.smeetz");
  LogService.info("Going to close attached chart in CustomerDisplay", {
    params: renderedChartData,
  });
  // Put here all data that are going to be needed by CustomerBasket.vue
  customerDisplayData = {
    message: "User closed attached chart",
    isBookingUpdated: false,
    isChartToUpdate: true,
    renderedChartData,
    renderCustomerSeatingChart: false,
    closeRenderedCustomerSeatingChart: true,
  };
  LogService.info("Populating attached data thru broadcast channel", {
    params: customerDisplayData,
  });
  // posting a message to pos.smeetz channel
  broadcastChannel.postMessage(JSON.stringify(customerDisplayData));
}

/**
 * This called after a user selects seats in the main screen, it will show the selected seats in the customer display as well
 */
export async function selectSeatsInCustomerDisplay(
  newlySelectedSeats: string[]
) {
  // Creating a broadcastChannel object linked to pos.smeetz
  const broadcastChannel = new BroadcastChannel("pos.smeetz");
  LogService.info("Going to select seats in chart in CustomerDisplay", {
    params: newlySelectedSeats,
  });
  // Put here all data that are going to be needed by CustomerBasket.vue
  customerDisplayData = {
    message: "User selected seats in chart",
    isBookingUpdated: true,
    isChartToUpdate: false, // we don't close the chart, nor we open it again (it is already opened and we keep it)
    newlySelectedSeats,
  };
  LogService.info("Populating attached data thru broadcast channel", {
    params: customerDisplayData,
  });
  // posting a message to pos.smeetz channel
  broadcastChannel.postMessage(JSON.stringify(customerDisplayData));
}

/**
 * This called after a user deselects seats in the main screen, it will deselect those seats in the customer display as well
 */
export async function deselectSeatsInCustomerDisplay(
  deselectedSeats: string[]
) {
  // Creating a broadcastChannel object linked to pos.smeetz
  const broadcastChannel = new BroadcastChannel("pos.smeetz");
  LogService.info("Going to select seats in chart in CustomerDisplay", {
    params: deselectedSeats,
  });
  // Put here all data that are going to be needed by CustomerBasket.vue
  customerDisplayData = {
    message: "User deselected seats in chart",
    isBookingUpdated: true,
    isChartToUpdate: false, // we don't close the chart, nor we open it again (it is already opened and we keep it)
    deselectedSeats,
  };
  LogService.info("Populating attached data thru broadcast channel", {
    params: customerDisplayData,
  });
  // posting a message to pos.smeetz channel
  broadcastChannel.postMessage(JSON.stringify(customerDisplayData));
}

/**
 * Open a new Electron window displaying CustomerDisplay component
 */
export function openCustomerDisplay() {
  const electronApi = window?.electronAPI;
  if (electronApi) {
    // Send a message to Electron to open a new window
    LogService.info("going to open customer facing display");
    electronApi.openNewWindow(`${window.location.origin}/customer-display`);
    console.log(
      `this is customer facing display route ${window.location.origin}/customer-display`
    );
    CommonModule.setIsCustomerDisplayOpened(true);
    LogService.info("customer facing display opened");
  }
}

/**
 * Close the customer display Electron window
 */
export function closeCustomerDisplay() {
  const broadcastChannel = new BroadcastChannel("pos.smeetz");
  console.log(broadcastChannel);
  // Disconnect the channel
  broadcastChannel.close();
  const electronApi = window?.electronAPI;
  if (electronApi) {
    // Send a message to Electron to close customer display
    LogService.info("going to close customer facing display");
    electronApi.closeNewWindow();
    LogService.info("customer facing display closed");
    CommonModule.setIsCustomerDisplayOpened(false);
  }
}

export const hasCustomerDisplay = computed(() => {
  if (
    DeviceModule.hardwareInfo &&
    DeviceModule.hardwareInfo.displays &&
    DeviceModule.hardwareInfo.displays.length > 1
  ) {
    return true;
    // // We only release this feature to DEV/TEST & our groups first
    // if (
    //   process.env.VUE_APP_ENV === "dev" ||
    //   process.env.VUE_APP_ENV === "test"
    // ) {
    //   return true;
    // }
    // if (
    //   POSConfigModule.groupId &&
    //   [1, 19066, /*VHS*/ 19469, /*VHS*/ 19380].includes(POSConfigModule.groupId)
    // ) {
    //   return true;
    // }
  }
  return false;
});
